'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = require('omit.js');

var _omit2 = _interopRequireDefault(_omit);

var _buttonGroup = require('./buttonGroup');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ButtonComponent(props) {
	var _classNames;

	var className = (0, _classnames2.default)((_classNames = {
		'mk-btn': true
	}, (0, _defineProperty3.default)(_classNames, 'mk-btn-' + props.type, !!props.type), (0, _defineProperty3.default)(_classNames, props.className, !!props.className), _classNames));

	var iconFontFamily = props.iconFontFamily,
	    iconShowStyle = props.iconShowStyle,
	    icon = props.icon,
	    other = (0, _objectWithoutProperties3.default)(props, ['iconFontFamily', 'iconShowStyle', 'icon']);


	var iconNode = icon ? _react2.default.createElement(_icon2.default, { type: icon, fontFamily: iconFontFamily, showStyle: iconShowStyle }) : null;

	var children = props.children || null;
	var ps = (0, _extends3.default)({}, other, { className: className });

	if (iconNode && !children) {
		return _react2.default.createElement(
			_button2.default,
			ps,
			iconNode
		);
	}

	if (iconNode && children) {
		return _react2.default.createElement(
			_button2.default,
			ps,
			iconNode,
			children
		);
	}

	return _react2.default.createElement(_button2.default, ps);
}

ButtonComponent.Group = _buttonGroup2.default;

exports.default = ButtonComponent;
module.exports = exports['default'];